<div class="ds-grid ds-grid--3">
	<!-- Primary Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Primary Variants</h3>
			<p class="ds-example__header-subtitle">Standard, outlined, and text variants</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Standard'"
					[size]="'small'"
					(action)="onButtonClick('Primary Standard')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Outlined'"
					[variant]="'outlined'"
					[size]="'small'"
					(action)="onButtonClick('Primary Outlined')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Text'"
					[variant]="'text'"
					[size]="'small'"
					(action)="onButtonClick('Primary Text')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Success Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Success Buttons</h3>
			<p class="ds-example__header-subtitle">With pre-icon support</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Success'"
					[color]="'success'"
					[preIcon]="'fa-solid fa-check-circle'"
					[size]="'small'"
					(action)="onButtonClick('Success')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Outlined'"
					[color]="'success'"
					[variant]="'outlined'"
					[preIcon]="'fa-regular fa-arrow-left'"
					[size]="'small'"
					(action)="onButtonClick('Success Outlined')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Info Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Info Buttons</h3>
			<p class="ds-example__header-subtitle">With post-icon support</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Info'"
					[color]="'info'"
					[postIcon]="'fa-solid fa-info-circle'"
					[size]="'small'"
					(action)="onButtonClick('Info')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Outlined'"
					[color]="'info'"
					[variant]="'outlined'"
					[postIcon]="'fa-regular fa-arrow-right'"
					[size]="'small'"
					(action)="onButtonClick('Info Outlined')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Warning Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Warning Buttons</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Warning'"
					[color]="'warning'"
					[preIcon]="'fa-solid fa-exclamation-triangle'"
					[size]="'small'"
					(action)="onButtonClick('Warning')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Outlined'"
					[color]="'warning'"
					[variant]="'outlined'"
					[postIcon]="'fa-regular fa-arrow-right'"
					[size]="'small'"
					(action)="onButtonClick('Warning Outlined')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Danger Buttons -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Danger Buttons</h3>
			<p class="ds-example__header-subtitle">With pre-icon and post-icon support</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Danger'"
					[color]="'danger'"
					[preIcon]="'fa-solid fa-exclamation-circle'"
					[postIcon]="'fa-regular fa-arrow-right'"
					[size]="'small'"
					(action)="onButtonClick('Danger')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Outlined'"
					[color]="'danger'"
					[variant]="'outlined'"
					[preIcon]="'fa-solid fa-exclamation-circle'"
					[postIcon]="'fa-regular fa-arrow-right'"
					[size]="'small'"
					(action)="onButtonClick('Danger Outlined')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- States -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Button States</h3>
			<p class="ds-example__header-subtitle">Disabled and loading states</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Disabled'"
					[disabled]="true"
					[size]="'small'"
					(action)="onButtonClick('Disabled')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Loading'"
					[loading]="true"
					[size]="'small'"
					(action)="onButtonClick('Loading')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Sizes -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Button Sizes</h3>
			<p class="ds-example__header-subtitle">Small, medium, and large sizes</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Small'"
					[size]="'small'"
					(action)="onButtonClick('Small')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Medium'"
					[size]="'medium'"
					(action)="onButtonClick('Medium')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Large'"
					[size]="'large'"
					(action)="onButtonClick('Large')">
				</eif-custom-button>
			</div>
		</div>
	</div>
</div>
